import createApiInstance from './apiFactory';
import { ENV } from '@/config/env';

export const API_V2 = createApiInstance({
  baseURL: ENV.URL!,
});
